// Kurzlinks: kurze, lesbare Adressen für Stellen, an denen niemand klicken kann (Text in einem Bild),
// die beim Aufruf auf die Zielseite mit UTM umschreiben. So bleiben geteilte Bilder messbar.
//
// Warum vor React (main.tsx) und nicht als <Navigate> im Router: Die Tracker (useUtmCapture,
// first_touch.landing_page, Sitzungsstart, GA) lesen window.location in Effekten, die VOR dem
// Effekt einer Weiterleitungs-Route laufen. Eine Router-Weiterleitung käme zu spät, die UTM wäre
// verloren. history.replaceState vor dem ersten Render dagegen sieht jeder Tracker. Kein Reload,
// kein Server, keine neue Infrastruktur.
//
// Abhängigkeitsfrei halten: Die Datei liegt im Einstieg jeder Seite.

/** Pfad im Teilen-Bild des Monatsrückblicks („charliescrew.com/rudel“). */
export const RECAP_KURZLINK_PFAD = "/rudel";
/** So steht der Link im Bild. */
export const RECAP_KURZLINK_TEXT = `charliescrew.com${RECAP_KURZLINK_PFAD}`;

/** Vormonat in Berlin als „recap_YYYY_MM“: geteilt wird fast nur in den Tagen nach dem Monatsersten. */
export function recapKampagne(jetzt: Date): string {
  const teile = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Berlin", year: "numeric", month: "2-digit" }).formatToParts(jetzt);
  let jahr = Number(teile.find((t) => t.type === "year")?.value);
  let monat = Number(teile.find((t) => t.type === "month")?.value) - 1;
  if (monat === 0) {
    monat = 12;
    jahr -= 1;
  }
  return `recap_${jahr}_${String(monat).padStart(2, "0")}`;
}

/**
 * Ziel-Adresse (Pfad + Query) für einen Kurzlink oder null, wenn der Pfad keiner ist.
 * Groß/klein und ein Schrägstrich am Ende sind egal; vorhandene Parameter bleiben erhalten,
 * eigene utm_* im Aufruf gewinnen (z. B. wenn jemand den Link mit UTM weitergibt).
 */
export function kurzlinkZiel(pathname: string, search: string, jetzt: Date): string | null {
  const pfad = pathname.toLowerCase().replace(/\/+$/, "");
  if (pfad !== RECAP_KURZLINK_PFAD) return null;
  const params = new URLSearchParams(search);
  const utm: Record<string, string> = {
    utm_source: "recap_bild",
    utm_medium: "social_share",
    utm_campaign: recapKampagne(jetzt),
  };
  for (const [k, v] of Object.entries(utm)) if (!params.has(k)) params.set(k, v);
  return `/?${params.toString()}`;
}

/** Vor dem ersten Render aufrufen (main.tsx). Darf nie werfen. */
export function kurzlinkAnwenden(): void {
  try {
    const ziel = kurzlinkZiel(window.location.pathname, window.location.search, new Date());
    if (ziel) window.history.replaceState(window.history.state, "", ziel + window.location.hash);
  } catch {
    /* Ein Kurzlink darf die Seite nie brechen; schlimmstenfalls landet man auf der 404. */
  }
}
